export const FEATURE_VENDOR_GCP_CO_SELL_ENABLED =
  'feature-vendor-gcp-co-sell-enabled';

export const FEATURE_CO_SELL_V3_UI_ENABLED = 'feature-co-sell-v3-ui-enabled';
